import { render, staticRenderFns } from "./RatingNumbers.vue?vue&type=template&id=693fd319"
import script from "./RatingNumbers.vue?vue&type=script&lang=js"
export * from "./RatingNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports